import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_search_sort extends PureComponent {
  render() {
    return (
      <div className="row" id="component_search_sort">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Search Sort</h2>
              <p>
                The Search Sort Component allows the user to change the order of
                the results in the search result component. Not all fields can
                be sorted. Numbers and DateTime fields (assuming they were set
                up correctly at the beginning) can be used to sort data. Text or
                free text fields can not be used to sort data. There is a
                workaround in the Nexoid library. You can create an additional
                number field that generates a number based on the first ten
                characters of the text field. Using the workflow component, you
                can keep these two fields permanently synced, and this will give
                you the ability to sort alphabetically on a text field.
              </p>
              <p>
                The search sort component works like a dropdown. The different
                search orders are stored in the options property. Name and order
                show the name and display order of the options in the dropdown
                list. The value is an array and contains the ElasticSearch
                syntax for that sort order. In the example, you will see the
                options to sort records by the newest and oldest. We are
                defining newest and oldest by the
                “object_created_by.date_created” field. The “_score” part of the
                sort order refers to the free text ranking score. Nexoid
                recommends always sorting by “_score” first, as this will give
                users the ability to free-text search. If you don’t sort by
                “_score” first and set sort order of
                “object_created_by.date_created” the results will always be in
                oldest created record regardless of what a user types into the
                free text search component.
              </p>

              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={true}
              />
              <InterfaceProperties
                type={"search_sort"}
                name={"sort search"}
                searchGroup={true}
                padding={true}
                hide={true}
                order={true}
                tabIndex={true}
                displayName={false}
                sourceUrl={false}
                sourceSave={false}
              />
              <h3>Options</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>

                  <tr>
                    <td className="b">name</td>
                    <td>
                      The displayed text name of the option.
                      <br />
                      <i>
                        <strong>"Select me"</strong>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">order</td>
                    <td>
                      The display order of options in the list.
                      <br />
                      <i>7</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">value</td>
                    <td>
                      The data value of the selected option.
                      <br />
                      <i>{"[ { ... }, { ... } ]"}</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Search Sort Example</h2>
            </section>
            <section>
              <h3>Example 1: Results Sort</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"search_sort"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"Sort Order"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"search_group"</span>:{" "}
                  <span className="jsonY">"record_results_1"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"options"</span>: &#123;
                </div>

                <div className="i2">
                  <span className="jsonG">"newest"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Newest"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"value"</span>: [
                </div>
                <div className="i4">
                  <span className="jsonY">"_score"</span>,
                </div>
                <div className="i4">&#123;</div>
                <div className="i5">
                  <span className="jsonY">
                    "object_created_by.date_created"
                  </span>
                  : &#123;
                </div>
                <div className="i6">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonY">"desc"</span>
                </div>
                <div className="i5">&#125;</div>
                <div className="i4">&#125;</div>
                <div className="i3">]</div>
                <div className="i2">&#125;,</div>

                <div className="i2">
                  <span className="jsonG">"oldest"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Oldest"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">2</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"value"</span>: [
                </div>
                <div className="i4">
                  <span className="jsonY">"_score"</span>,
                </div>
                <div className="i4">&#123;</div>
                <div className="i5">
                  <span className="jsonY">
                    "object_created_by.date_created"
                  </span>
                  : &#123;
                </div>
                <div className="i6">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonY">"asc"</span>
                </div>
                <div className="i5">&#125;</div>
                <div className="i4">&#125;</div>
                <div className="i3">]</div>
                <div className="i2">&#125;</div>

                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_search_sort;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_search_sort.js